import { Box, Typography, styled } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * Oversized hover target so it is easy to trigger on desktop.
 * Negative margin compensates the extra padding so layout is unaffected.
 */
export const TriggerBox = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  cursor: "pointer",
  padding: "4px 6px",
  margin: "-4px -6px",
  borderRadius: "6px",
  userSelect: "none",
  "&:hover": {
    backgroundColor: "rgba(107, 122, 148, 0.08)",
  },
});

export const ExplanationIcon = styled(InfoOutlinedIcon)({
  fontSize: "16px",
  color: "#6B7A94",
  flexShrink: 0,
});

export const ExplanationLabel = styled(Typography)({
  fontSize: "14px",
  fontFamily: "Nunito, sans-serif",
  color: "#6B7A94",
  fontWeight: 500,
}) as typeof Typography;
